import type { IconValue } from '../constants';

import { Url } from '../constants';

type GetIcon = (name: IconValue) => string;

export const getIconUrl: GetIcon = (name) => `${Url.ICONS}${name}`;
